import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { FaEdit } from "react-icons/fa";

export default function useColumnsCadena(togglePop, guardarSelectedCadena) {
	const [t] = useTranslation('global');
	
	const onEditarCadena = (cadena) => {
		guardarSelectedCadena(cadena);
		togglePop();
	}
	
	const columns = useMemo(
		() => [
				{
					Header: t('app.cadena.table.nombreCadena'),
					Cell: ({row}) => (
						<div>
							<p className="letra-grisClaro-columna">{row.original.nombre}</p>
						</div>
					)
				},
				{
					accessor: 'action',
					Cell: ({row}) => (
						<div className="container-actionsTabla">
							<button className={'button-actionRecord'} onClick={(e) => onEditarCadena(row.original, e)}><FaEdit size='20' className={'icon-button-editarRecord'}/></button>
						</div>
					),
				}
			],[t]
	);
	
	return columns
}